import { useParams } from "react-router-dom";
import { Construction, Check } from "lucide-react";
import AdminShell from "../../components/AdminShell";
import ConnectorIcon from "../../components/ConnectorIcon";
import { COMING_SOON } from "../../components/adminCenters";
import { CustomerPanel, StatusBadge } from "../../components/customer/CustomerUI";

export default function ComingSoonCenter() {
  const { key } = useParams();
  const info = COMING_SOON[key];

  if (!info) {
    return <AdminShell title="Not found"><div className="text-slate-600">Unknown center.</div></AdminShell>;
  }

  return (
    <AdminShell title={info.name} subtitle={info.desc}>
      <CustomerPanel className="max-w-2xl" data-testid={`coming-soon-${key}`}>
        <div className="px-ui-4 py-ui-4 sm:px-ui-5">
        <StatusBadge tone="warning"><Construction className="h-3.5 w-3.5" /> Planned module</StatusBadge>
        <div className="mt-4 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center border border-slate-300 bg-slate-50">
            <ConnectorIcon name={info.icon} className="h-6 w-6 text-slate-700" />
          </div>
          <div>
            <h2 className="font-heading text-2xl font-bold text-slate-900">{info.name}</h2>
            <StatusBadge tone="neutral">Depends on: {info.depends}</StatusBadge>
          </div>
        </div>

        <div className="mt-6">
          <div className="mb-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">Planned Capabilities</div>
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {info.capabilities.map((c) => (
              <li key={c} className="flex items-center gap-2 border border-slate-300 bg-slate-50 px-3 py-2 text-sm text-slate-700">
                <Check className="h-3.5 w-3.5 text-emerald-400" /> {c}
              </li>
            ))}
          </ul>
        </div>

        <p className="mt-6 text-sm text-slate-500">
          This center is architected as a pluggable module. It will be enabled in a later phase without redesigning the Admin Dashboard, database, or API.
        </p>
        </div>
      </CustomerPanel>
    </AdminShell>
  );
}
